import { supabase } from '../supabaseClient';
import { getOrgId } from './orgStore';

const ORG_TABLE = 'organizations';

export const fetchOrganisation = async () => {
  const orgId = getOrgId();
  if (!orgId) throw new Error('No org selected (org_id is null).');

  const { data, error } = await supabase
    .from(ORG_TABLE)
    .select('*')
    .eq('id', orgId)
    .single();

  if (error) throw error;
  return data;
};

export const updateOrganisation = async (partial) => {
  const orgId = getOrgId();
  if (!orgId) throw new Error('No org selected (org_id is null).');

  const payload = {
    ...partial,
    updated_at: new Date().toISOString(),
  };

  const { data, error } = await supabase
    .from(ORG_TABLE)
    .update(payload)
    .eq('id', orgId)
    .select('*')
    .single();

  if (error) throw error;

  await syncSetupRow(orgId, data);

  return data;
};

/**
 * Mirror the org's company details into the `setup` table (one row per org)
 * so invoice/quote PDFs and emails pick them up. Upserts on org_id, which
 * has a unique constraint; setup.id is auto-generated by the DB.
 */
const syncSetupRow = async (orgId, org) => {
  const setupRow = {
    org_id: orgId,
    companyname: org.name ?? null,
    abnno: org.abn ?? null,
    company_phone: org.phone ?? null,
    street: org.street ?? null,
    city: org.city ?? null,
    state: org.state ?? null,
    postcode: org.postcode ?? null,
    sales_email: org.sales_email ?? null,
    purchase_email: org.purchase_email ?? null,
  };

  const { error } = await supabase
    .from('setup')
    .upsert(setupRow, { onConflict: 'org_id' });

  if (error) throw error;
};

